<template>
  <v-app class="app">
    <div :class="`bg ${display.mobile ? 'mobile' : 'pa-10'}`" />
    <div class="logo" />
    <v-main class="d-flex align-center justify-center">
      <slot />
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import { useDisplay } from "vuetify";
const display = ref(useDisplay());
</script>

<style lang="scss" scoped>
.app {
  position: relative;
  height: 100vh;
}

.bg {
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("/rvs/background.png");
  background-size: cover;
  width: 100vw;
  height: 100vh;
  margin: 5% 0 0 5%;
  &.mobile {
    background-position: center;
  }
}

.logo {
  position: fixed;
  top: 30px;
  right: 30px;
  background-image: url("/logo.png");
  background-size: contain;
  height: 100vh;
  width: 200px;
}
</style>
